export const NAME = 'CITIES';

export const cities = (store) => store[NAME].list.data || [];
export const citiesPageMeta = (store) => store[NAME].list.page || {};
export const getPaginatedCities = (store) => store[NAME].list.allData || [];
